<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { SvelteComponent } from "svelte";
    import { createEventDispatcher } from "svelte";

    import { ModalToken } from "../../modal-manager";
    import { modalManagerContextKey } from "../../modal-manager/constants";
    import Modal from "./Modal.svelte";
    import ModalDialog from "./ModalDialog.svelte";

    export let modalToken: ModalToken;
    export let modalStyle: string | undefined = undefined;
    export let modalClass: string | undefined = undefined;
    export let dialogStyle: string | undefined = undefined;
    export let dialogClass: string | undefined = undefined;
    export let modalBodyClass: string | undefined = undefined;
    export let title: string | undefined = undefined;
    export let variant: ModalDialog["variant"] = "";
    export let closeIcon: typeof SvelteComponent | undefined = undefined;
    export let disableCloseButton = false;
    export let disableClose = false;
    export let disablePortal = false;
    export let disableFocusTrap = false;

    const modalManager = getTypedContext(modalManagerContextKey);
    const dispatch = createEventDispatcher();

    modalManager.addModal(modalToken);
    const isOpen$ = modalManager.selectIsOpen(modalToken);
    const openedModalOrder$ = modalManager.selectModalOrder(modalToken);
    const openedModalsCount$ = modalManager.selectOpenedModalsCount();

    const handleCloseModal = () => {
        if (!disableClose) {
            modalManager.closeModal(modalToken);
            dispatch("close");
        }
    };
</script>

<Modal
    on:gw_modal_close={handleCloseModal}
    on:keydown
    style={modalStyle}
    open={$isOpen$}
    class={modalClass}
    {disablePortal}
    openedModalOrder={$openedModalOrder$}
    openedModalsCount={$openedModalsCount$}
>
    <ModalDialog
        class={dialogClass}
        {modalBodyClass}
        style={dialogStyle}
        {title}
        on:gw_modal_close={handleCloseModal}
        {variant}
        {closeIcon}
        {disableCloseButton}
        isOpen={$isOpen$}
        {disableFocusTrap}
    >
        <slot />
    </ModalDialog>
</Modal>
